import React, { useEffect, useState } from 'react';
import Button from "components/CustomButtons/Button.js";
import Snackbar from "components/Snackbar/Snackbar.js";
import AddAlert from "@material-ui/icons/AddAlert";
import { Modal, Form, Col } from "react-bootstrap";
import 'bootstrap/dist/css/bootstrap.min.css';

import DatePicker from "components/Datepicker/Datepicker";
import api from "assets/services/api";


function ModalUpdate(props) {


  Date.prototype.withoutTime = function () {
    var d = new Date(this);
    d.setHours(0, 0, 0, 0);
    return d;
  }

  const [br, setBR] = React.useState(false);

  const [products, setProducts] = useState([]);
  const [operatorId, setOperatorId] = useState(props.props.id_operator);
  const [productId, setProductId] = useState(props.props.id_product);
  const [amount, setAmount] = useState(props.props.amount);
  const [startDate, setStartDate] = useState(new Date(props.props.date_of_issued).withoutTime());
  const [controlSnack, setControlSnack] = useState(false);


  const showNotification = place => {
    switch (place) {
      case "br":
        if (!br) {
          setBR(true);
          setTimeout(function () {
            setBR(false);
            setControlSnack(false);
          }, 6000);
        }
        break;
      default:
        break;
    }
  };


  useEffect(() => {
    loadProducts();
  }, []);

  async function loadProducts() {
    const response = await api.get('/product');

    setProducts(response.data);
  }

  async function handleAddProduct(e) {
    e.preventDefault();

    if (amount === undefined || amount <= 0) {
      return alert('Quantidade inválida');
    }
    const response = await api.put('/storage/'+props.props.id, {
      validated: false,
      amount: amount,
      date_of_issued: startDate,
      id_operator: operatorId,
      id_product: productId ? productId : products[0].id
    });
    if (response.status === 200) {
      setControlSnack(true);
      props.onHide();
      if(!props.dashboard)
      props.loadStorage();
    }
  }

  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          Editar estoque
          </Modal.Title>
      </Modal.Header>
      <Form onSubmit={handleAddProduct}>
        <Modal.Body>
          <Form.Row>
            <Form.Group as={Col} controlId="formGridProduct">
              <Form.Label>Produtos</Form.Label>
              <Form.Control onChange={event => setProductId(event.target.value)} value={productId} as="select" defaultValue="Choose...">
                {products.map(product => (
                  <option value={product.id}>{product.name}</option>
                ))}
              </Form.Control>
            </Form.Group>

            <Form.Group controlId="formGridAmount">
              <Form.Label>Quantidade</Form.Label>
                <Form.Control onChange={event => setAmount(event.target.value)} type="number" value={amount} placeholder="Quantidade de produtos"></Form.Control>
            </Form.Group>
          </Form.Row>
          <Form.Row>
            <Form.Group as={Col} controlId="formGridDate">
              <Form.Label>Data</Form.Label>
              <div>
                <DatePicker 
                  selected={startDate}
                  onChange={date => setStartDate(date.withoutTime())}
                  dateFormat="dd/MM/yyyy"
                  placeholderText="Digite ou clique aqui"
                  disabledKeyboardNavigation />
                  </div>
            </Form.Group>
          </Form.Row>

        </Modal.Body>
        <Modal.Footer>
          <div className="d-flex justify-content-center">
            <Button color="success" type="submit" onClick={controlSnack ? () => showNotification("br") : () => showNotification("nf")}>
              Editar
          </Button>
            <Snackbar
              place="br"
              color="success"
              icon={AddAlert}
              message="Estoque editado com sucesso"
              open={br}
              closeNotification={() => setBR(false)}
              close
            />
          </div>
        </Modal.Footer>
      </Form>
    </Modal>
  );
}

export default ModalUpdate;